import React from 'react'
import Layout from '../../../components/layout/Layout'
import FrameworksLab from '../../../components/pages/frameworks/FrameworksLab'

const siteMetadata = {
  description: "Compare and select the right multi-agent framework for your project",
  title: "Multi-Agent Frameworks Comparison",
  author: "Victor Dibia",
  image: "/images/og-card.png", 
  keywords: "multi-agent frameworks, comparison, autogen, crewai, langraph, swarm",
  twitterUsername: "@designingwithml",
};

const FrameworksPage: React.FC = () => {
  return (
    <Layout meta={siteMetadata} title="Frameworks" link={"/labs/frameworks"}>
      <main className="">
        <div className="mb-6"></div>
        <FrameworksLab />
      </main>
    </Layout>
  )
}

export default FrameworksPage